// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categoryPage_wrapper__Asfhx {
  width: 100%;
  height: 100%;
  color: #212121;
  display: flex;
  flex-direction: column; }

.categoryPage_tabs__JQrmV {
  position: relative;
  display: flex;
  gap: 20px; }

.categoryPage_tab__NNMHX {
  padding: 15px 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  text-decoration: none;
  transition: all 0.4s; }
  .categoryPage_tab__NNMHX span {
    transition: all 0.4s; }

.categoryPage_active__y7jTU {
  color: #fe6100;
  border-bottom: 3px solid #FE6100; }

.categoryPage_noActive__CloWH {
  color: #212121;
  border-bottom: 3px solid #FFFFFF; }
  .categoryPage_noActive__CloWH:active span {
    color: #b62f00; }
  .categoryPage_noActive__CloWH:hover {
    background: rgba(254, 97, 0, 0.1);
    border-bottom: 3px solid rgba(254, 97, 0, 0.1); }
    .categoryPage_noActive__CloWH:hover span {
      color: #fe6100; }

.categoryPage_modal__0g0yI {
  max-width: 560px;
  max-height: 850px;
  height: max-content;
  overflow: hidden;
  position: relative;
  background-color: #ffffff;
  z-index: 2; }

.categoryPage_actionsBlock__VzeUS {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px; }
  .categoryPage_actionsBlock__VzeUS svg {
    cursor: pointer;
    color: #666666; }

.categoryPage_categoryHeader__Zyodl {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px; }

.categoryPage_categoryTitle__HPq3s {
  font-weight: 600;
  font-size: 24px;
  line-height: 150%; }

.categoryPage_title__\\+tMZE {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px; }

.categoryPage_plainText__SVGQ- {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #666666; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/categoryPage/categoryPage.module.scss","webpack://./src/styles/common.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB,EAAA;EAPtB;IASI,oBAAoB,EAAA;;AAGxB;EACE,cAAc;EACd,gCAAgC,EAAA;;AAElC;EACE,cAAc;EACd,gCAAgC,EAAA;EAFlC;IAKM,cAAc,EAAA;EALpB;IASI,iCAAiC;IACjC,8CAA8C,EAAA;IAVlD;MAYM,cAAc,EAAA;;AAKpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU,EAAA;;AAGZ;EC1DE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;ED0DvB,eAAe,EAAA;EAFjB;IAII,eAAe;IACf,cAA6B,EAAA;;AAIjC;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB,EAAA;;AAGlB;EEvEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;AFyEnB;EE/DE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;AFiEnB;EE3CE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EF2CjB,cAA6B,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.wrapper {\n  width: 100%;\n  height: 100%;\n  color: #212121;\n  display: flex;\n  flex-direction: column;\n}\n\n.tabs {\n  position: relative;\n  display: flex;\n  gap: 20px;\n}\n\n.tab {\n  padding: 15px 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  text-decoration: none;\n  transition: all 0.4s;\n  span{\n    transition: all 0.4s;\n  }\n}\n.active {\n  color: #fe6100;\n  border-bottom: 3px solid #FE6100;\n}\n.noActive {\n  color: #212121;\n  border-bottom: 3px solid #FFFFFF;\n  &:active {\n    span {\n      color: #b62f00;\n    }\n  }\n  &:hover {\n    background: rgba(254, 97, 0, 0.1);\n    border-bottom: 3px solid rgba(254, 97, 0, 0.1);\n    span {\n      color: #fe6100;\n    }\n  }\n}\n\n.modal {\n  max-width: 560px;\n  max-height: 850px;\n  height: max-content;\n  overflow: hidden;\n  position: relative;\n  background-color: #ffffff;\n  z-index: 2;\n}\n\n.actionsBlock {\n  @include flexCenter;\n  column-gap: 8px;\n  svg {\n    cursor: pointer;\n    color: rgba(102, 102, 102, 1);\n  }\n}\n\n.categoryHeader {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.categoryTitle {\n  @include h2\n}\n\n.title {\n  @include h4\n}\n\n.plainText {\n  @include body2;\n  color: rgba(102, 102, 102, 1);\n}","\n@mixin flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `categoryPage_wrapper__Asfhx`,
	"tabs": `categoryPage_tabs__JQrmV`,
	"tab": `categoryPage_tab__NNMHX`,
	"active": `categoryPage_active__y7jTU`,
	"noActive": `categoryPage_noActive__CloWH`,
	"modal": `categoryPage_modal__0g0yI`,
	"actionsBlock": `categoryPage_actionsBlock__VzeUS`,
	"categoryHeader": `categoryPage_categoryHeader__Zyodl`,
	"categoryTitle": `categoryPage_categoryTitle__HPq3s`,
	"title": `categoryPage_title__+tMZE`,
	"plainText": `categoryPage_plainText__SVGQ-`
};
export default ___CSS_LOADER_EXPORT___;
